import { Record } from 'immutable';

export default class AvailableDate extends Record({
  id: undefined,
  date: undefined,
  period1status: undefined,
  period2status: undefined,
  period3status: undefined,
  period4status: undefined,
  period5status: undefined,
  period6status: undefined,
  period7status: undefined,
  period8status: undefined,
}) {
}
